<div class="card p-6! bg-slate-900 text-white" *transloco="let t; prefix: 'wizard.project'">
  <h1 data-testid="office-step-title" class="text-xl font-semibold mb-6">{{ t('addOffice') }}</h1>

  <div class="mb-8 border-b border-slate-700">
    <ul class="flex" data-testid="company-tabs">
      @for (company of selectedCompanies(); track company.id) {
        <li>
          <button
            class="px-3 py-1 border-b-2 transition-colors duration-300"
            [ngClass]="{
              'border-blue-500 text-white font-semibold': selectedCompanyId() === company.id,
              'border-transparent text-gray-400 hover:text-white':
                selectedCompanyId() !== company.id,
            }"
            (click)="setSelectedCompany(company.id)"
            [attr.data-testid]="'company-tab-' + company.id"
          >
            {{ company.name }}
          </button>
        </li>
      }
    </ul>
  </div>

  <h2 class="text-lg font-medium mb-6">{{ t('selectOfficesText') }}</h2>

  @for (country of countriesForSelectedCompany(); track country.id) {
    <div class="mb-6">
      <h2
        class="text-lg font-semibold mb-3 text-gray-200"
        [attr.data-testid]="'country-' + country.id"
      >
        {{ country.name }}
      </h2>

      <div class="card">
        <p-table
          [value]="getOfficesForCountry(country.id)"
          dataKey="id"
          class="p-datatable-striped"
        >
          <ng-template #header>
            <tr>
              <th class="text-center w-1/6" scope="col">{{ 'common.office' | transloco }}</th>
              <th class="text-center w-1/6" scope="col">{{ 'common.city' | transloco }}</th>
              <th class="text-center w-1/3" scope="col">{{ 'common.functions' | transloco }}</th>
            </tr>
          </ng-template>
          <ng-template #body let-office>
            <tr>
              <td>
                <div class="p-3">
                  <p-checkbox
                    [binary]="true"
                    [ngModel]="isOfficeSelected(office.id)"
                    (onChange)="toggleOfficeSelection(office.id)"
                    [attr.data-testid]="'office-checkbox-' + office.id"
                  >
                  </p-checkbox>
                  <span class="ml-3">{{ office.name }}</span>
                </div>
              </td>
              <td>{{ office.cityName }}</td>
              <td>
                <div class="flex items-center">
                  <span class="grow">
                    @for (
                      moduleInfo of getOfficeFunctionsDisplayWithTooltipData(office);
                      track moduleInfo.moduleName
                    ) {
                      <span
                        [pTooltip]="tooltipTemplate"
                        [tooltipStyleClass]="'large-tooltip'"
                        tooltipPosition="top"
                        class="module-function-tooltip"
                      >
                        {{ moduleInfo.moduleName }} ({{ moduleInfo.count }})

                        <ng-template #tooltipTemplate>
                          <div class="custom-tooltip-content">
                            {{ moduleInfo.functionNames.join(', ') }}
                          </div>
                        </ng-template>
                      </span>
                    }
                  </span>
                  <div class="shrink-0">
                    <button
                      class="flex items-center justify-center rounded-full bg-primary w-5 h-5"
                      (click)="selectFunctions(office)"
                      [attr.data-testid]="'functions-dialog-' + office.id"
                    >
                      <i class="pi pi-plus" style="font-size: 0.8rem; font-weight: bold"></i>
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  }
</div>

<app-function-selection-dialog
  [visible]="dialogStateService.dialogVisible()"
  [label]="dialogStateService.currentEntityName()"
  (visibleChange)="$event ? null : dialogStateService.closeDialog()"
  (selectedFunctions)="onFunctionsSelected($event)"
  [initialSelectedFunctions]="getSelectedFunctionsForDialog()"
  [restrictToAvailableFunctions]="true"
  [translationPrefix]="dialogTranslationPrefix"
></app-function-selection-dialog>
